import { render, staticRenderFns } from "./ClubAppointmentFailed.vue?vue&type=template&id=6aafaaa4&"
import script from "./ClubAppointmentFailed.vue?vue&type=script&lang=js&"
export * from "./ClubAppointmentFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aafaaa4')) {
      api.createRecord('6aafaaa4', component.options)
    } else {
      api.reload('6aafaaa4', component.options)
    }
    module.hot.accept("./ClubAppointmentFailed.vue?vue&type=template&id=6aafaaa4&", function () {
      api.rerender('6aafaaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/dependencies/ClubAppointment/ClubAppointmentFailed.vue"
export default component.exports